import React from 'react';
import AttributesDefinition from './AttributesDefinition';

const AttributesDefinitionContainer = () => (
  <AttributesDefinition />
);

export default AttributesDefinitionContainer;
